import { ChartDefinition, ChartKey, ChartRendererType } from '@frontend/chart/types';

import { TRANSACTION_VOLUME_CHART_ENDPOINT } from '../transaction-chart-endpoints';

export const TRANSACTION_VOLUME_LINE_CHART_DEFINITION: ChartDefinition = {
    key: ChartKey.TRANSACTION_VOLUME_LINE,
    chartType: ChartRendererType.LINE,
    endpoint: TRANSACTION_VOLUME_CHART_ENDPOINT,
    filters: []
};
